import { ExtractStatus } from './common.js';

export const Kind = 'EXTRACT_PATIENT_ADVISORY_DOCUMENTS' as const;
export { ExtractStatus as Status };
